/**
 * /tenants/$slug/access-governance/history — Identity Governance History.
 *
 * Read-only retrospective of decided/closed access + recovery requests, with a
 * URL-driven date-range / type / outcome filter and CSV/NDJSON export. The
 * loader prefetches the first page so the table is warm on navigation.
 */

import { createFileRoute } from "@tanstack/react-router";
import { historyFilterSchema } from "@/features/access-governance/schemas";
import { fetchHistory, historyQueryKey } from "@/features/access-governance/queries";
import { AccessGovernanceHistoryPage } from "@/features/access-governance/pages/access-governance-history-page";

export const Route = createFileRoute(
  "/_authed/tenants/$slug/access-governance/history",
)({
  validateSearch: historyFilterSchema,
  loaderDeps: ({ search }) => ({ search }),
  loader: ({ context, deps }) =>
    context.queryClient.ensureQueryData({
      queryKey: historyQueryKey(context.tenant.id, deps.search),
      queryFn: () => fetchHistory(context.tenant.id, deps.search),
    }),
  component: AccessGovernanceHistoryPage,
});
